import React, { useEffect } from "react";
import { useProjectData } from "../../projects/ProjectDataContext";
import { useProjects } from "../../auth/ProjectContext";

function loadStyle(href: string) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

function loadScript(src: string) {
  return new Promise<void>((resolve) => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve();
    document.body.appendChild(s);
  });
}

export default function GanttChartView() {
  const { currentProject } = useProjects();
  const { projects } = useProjectData();
  const project = projects.find((p) => p.id === currentProject?.id);

  useEffect(() => {
    loadStyle("https://cdn.dhtmlx.com/gantt/edge/dhtmlxgantt.css");
    Promise.all([
      loadScript("https://cdn.dhtmlx.com/gantt/edge/dhtmlxgantt.js"),
    ]).then(() => {
      const gantt: any = (window as any).gantt;
      if (!gantt || !project) return;
      gantt.config.date_format = "%Y-%m-%d";
      gantt.init("gantt_here");
      const tasks = project.tasks.map((t) => ({
        id: t.id,
        text: t.name,
        start_date: t.dueDate,
        duration: 1,
        progress: t.status === "Completed" ? 1 : 0,
      }));
      gantt.parse({ data: tasks, links: [] });
    });
  }, [project]);

  return <div id="gantt_here" style={{ width: "100%", height: "80vh" }} />;
}
